import { render, staticRenderFns } from "./TreeColumns.vue?vue&type=template&id=96d3b224&"
import script from "./TreeColumns.vue?vue&type=script&lang=js&"
export * from "./TreeColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports